<template>
	<div :class="groupClass">
		<label :class="labelClass">{{ text }}</label>
	</div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
	name: 'DmsLabel',
	props: {
		groupClass: { type: String, default: 'frm-group-label' },
		labelClass: { type: String, default: 'frm-label' },
		text: String,
	},
});
</script>

<style>
</style>
